import PropTypes from "prop-types";
import { maskEmail } from "../../utils/formatters";
import { Card, CardHeader, InfoItem } from "../ui";

const CustomerDetails = ({ customer }) => {
  if (!customer) return null;

  const hasInfo = customer.name || customer.email || customer.phone;
  if (!hasInfo) return null;

  return (
    <Card className="mb-4">
      <div className="px-4 sm:px-6 pt-4 sm:pt-5 pb-2 sm:pb-3">
        <h3 className="text-sm sm:text-base font-bold" style={{ color: "#3B3B3B" }}>
          Your Details
        </h3>
      </div>
      <div className="px-4 sm:px-6 pb-4 sm:pb-5">
        <div className="space-y-2 sm:space-y-3">
          <InfoItem label="Name" value={customer?.name} />
          <InfoItem label="Email" value={customer?.email ? maskEmail(customer.email) : null} />
          <InfoItem label="Phone Number" value={customer?.phone} />
        </div>
      </div>
    </Card>
  );
};

CustomerDetails.propTypes = {
  customer: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
  }),
};

export default CustomerDetails;
